import React, { useEffect, useState } from 'react';
import { Field, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, Toggler, TextInput, Icons } from '@components';
import { mdiFileDownloadOutline } from '@mdi/js';
import { IsencaoInitialValues, IsencaoSchema, IsencaoDocs } from '@schemas';
import { enviaFormRequest } from '@store/user/actions';
import { validaUpload } from './utils/validaUpload';
import { ModalUpload } from './components/ModalUpload';
import { RequerimentoService } from '../../../../common/services/requerimento';

const Anexos = () => {
  const docs = IsencaoDocs;
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      <ModalUpload modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen} />
      {docs.commons.map((anexo) => (
        <div className="row" key={anexo.name}>
          <div className="col-md-12 col-lg-6">
            <Field
              className="mb-3"
              name={anexo.name}
              type="file"
              label={anexo.label}
              accept="image/*,.pdf"
            >
              {({ form }) => {
                return (
                  <TextInput
                    className="mb-3"
                    name={anexo.name}
                    type="file"
                    label={anexo.label}
                    accept="image/*,.pdf"
                    multiple
                    onChange={(e) => {
                      return validaUpload({
                        anexo,
                        e,
                        form,
                        setModalIsOpen,
                      });
                    }}
                  />
                );
              }}
            </Field>
          </div>
        </div>
      ))}
    </>
  );
};

const service = new RequerimentoService();

export const Isencao = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [fileURL, setFileURL] = useState('');

  useEffect(() => {
    service
      .obterTermoInfoMedicaComplementares()
      .then((URL) => setFileURL(URL))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>
        <p>
          Venho, por meio deste, apresentar à Fundação Forluminas de Seguridade
          Social - FORLUZ, laudo para isenção de Imposto de Renda.
        </p>
        <p>Orientações para envio do laudo </p>
        <p>
          Laudo emitido pelo INSS: anexar a este formulário cópia do laudo
          digital emitido pelo INSS.
        </p>
        <p>
          Laudo emitido por outro órgão oficial: anexar a este formulário cópia
          autenticada em cartório do laudo emitido por órgão oficial (SUS) em
          papel timbrado juntamente com o formulário de Informações
          Complementares preenchido pelo mesmo médico que forneceu o laudo
          citado.
        </p>
        <p>
          O pleito de isenção deverá ser apresentado junto a todas as fontes
          pagadoras (Forluz e INSS).
        </p>
        <p className="mb-4">
          O pedido de restituição dos valores anteriormente tributados deve ser
          requerido junto à Receita Federal, por meio administrativo.
        </p>
        <Formik
          validateOnMount
          initialValues={IsencaoInitialValues}
          validationSchema={IsencaoSchema}
          onSubmit={(values) => {
            dispatch(
              enviaFormRequest({
                campos: values,
                formulario: reference,
                navigate,
              })
            );
          }}
        >
          {({ handleSubmit, isValid }) => (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12">
                  {loading ? (
                    <p className="mb-4">
                      Carregando formulário de informações médicas
                      complementares...
                    </p>
                  ) : (
                    <a
                      href={fileURL}
                      rel="noreferrer"
                      target="_blank"
                      download
                      title="Clique para termo de compromisso"
                      className="w-250 mb-4 d-md-flex ts-14 mb-2 mt-4 align-items-center justify-content-between text-decoration-none fw-bold primary-color"
                    >
                      Baixar formulário de informações médicas complementares
                      <Icons
                        path={mdiFileDownloadOutline}
                        color="var(--primary-color)"
                      />
                    </a>
                  )}

                  <p className="mb-4">
                    Com base na Lei nº 13.709/2018 (Lei Geral de Proteção de
                    Dados Pessoais), autorizo o tratamento dos meus dados
                    pessoais e dados pessoais sensíveis para fins relacionados
                    ao meu vínculo com a FORLUZ.
                  </p>
                  <Field
                    className="mb-3"
                    name="consentimentoDadosSensiveis"
                    component={Toggler}
                    label="Consentimento dados sensíveis (obrigatório)"
                  />
                </div>
              </div>

              <Anexos />

              <hr className="mt-32 mt-xs-0 mb-32" />

              <div className="row">
                <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                  <div className="d-block d-md-flex align-items-center">
                    <Button
                      disabled={!isValid}
                      className="ms-0 ms-md-3"
                      onClick={handleSubmit}
                    >
                      Continuar
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
